import React, { useEffect, useState } from "react";
import ReactEcharts from "echarts-for-react";
import toast from "react-hot-toast"
import { Card, CardBody, Col, FormGroup, Input, Label, Row } from "reactstrap";
import useApi from "common/ApiMiddlewere";
import Select from "react-select";
import { dateFormat } from "pages/Common";
// import getChartColorsArray from "../../../components/Common/ChartsDynamicColor";

const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        return {
            ...styles,
            border: "1px solid #ced4da",
            minHeight: "35px",
            padding: "3px 10px",
            fontSize: "12px",
            backgroundColor: isDisabled ? "#e9ecef" : "#fff",
            color: isDisabled ? "#6c757d" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            pointerEvents: isDisabled ? "none" : "auto",  // Important for full disabling
            opacity: isDisabled ? 0.6 : 1,
        };
    },
}

const LineBar = ({ dataColors, loader }) => {

    const { getApi, postApi } = useApi()
    const [data, setData] = useState([])
    const [filterType, setFilterType] = useState("MONTH")
    const [months, setMonths] = useState([])
    const [years, setYears] = useState([])
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [seletedMonth, setSeletedMonth] = useState()
    const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ]

    useEffect(() => {
        const monthOptions = monthNames.map((month) => ({
            label: month,
            value: month
        }));
        setMonths(monthOptions);

        const currentMonth = monthOptions[new Date().getMonth()];
        setSeletedMonth(currentMonth?.label);

        const currentYear = new Date().getFullYear();
        const yearOptions = [0, 1, 2].map((i) => {
            const year = currentYear - i;
            return {
                label: year.toString(),
                value: year.toString()
            };
        });
        setYears(yearOptions);

    }, []);

    const bookingChartAPICall = async (fromDate, toDate) => {
        loader(true);
        postApi("Report/booking-chart", {
            filterType,
            fromDate,
            toDate,
        }).then(({ data, status }) => {
            if (status === 200) {
                loader(false)
                setData(data)
            } else {
                loader(false)
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }

    function getMonthDateRange(monthName, year) {
        const monthIndex = new Date(`${monthName} 1, ${year}`).getMonth();
        const fromDate = new Date(year, monthIndex, 1);
        const toDate = new Date(year, monthIndex + 1, 0);
        return { fromDate, toDate };
    }

    useEffect(() => {
        if (filterType === "MONTH" && seletedMonth && selectedYear) {
            const { fromDate, toDate } = getMonthDateRange(seletedMonth, selectedYear);
            bookingChartAPICall(dateFormat(fromDate, "yyyy-MM-dd"), dateFormat(toDate, "yyyy-MM-dd"))
        } else if (filterType === "YEAR" && selectedYear) {
            bookingChartAPICall(`${selectedYear}-01-01`, `${selectedYear}-12-31`)
        } else if (filterType === "ALL") {
            bookingChartAPICall(null, null)
        }
    }, [filterType, seletedMonth, selectedYear])

    const options = {
        grid: {
            zlevel: 0,
            x: 90,
            x2: 40,
            y: 30,
            y2: 30,
            borderWidth: 0,
            backgroundColor: "rgba(0,0,0,0)",
            borderColor: "rgba(0,0,0,0)",
        },
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "cross",
                crossStyle: {
                    color: "#999",
                },
            },
        },
        toolbox: {
            orient: "center",
            left: 0,
            top: 20,
            feature: {
                // dataView: { show: true, readOnly: false, title: "Data View" },
                magicType: { show: true, type: ["line", "bar"], title: { line: "For line chart", bar: "For bar chart" } },
                // restore: { show: true, title: "restore" },
                saveAsImage: { show: true, title: "Download Image" },
            },
        },
        color: "#227C70",
        legend: {
            data: ["Bookings"],
            textStyle: {
                color: ["#8791af"],
            },
        },
        xAxis: [
            {
                type: "category",
                data: data.map(({ Label }) => Label),
                axisPointer: {
                    type: "shadow",
                },
                axisLine: {
                    lineStyle: {
                        color: "#8791af",
                    },
                },
            },
        ],
        yAxis: [
            {
                type: "value",
                name: "Total booking",
                // min: 0,
                // max: 250,
                // interval: 50,
                axisLine: {
                    lineStyle: {
                        color: '#8791af'
                    },
                },
                splitLine: {
                    lineStyle: {
                        color: "rgba(166, 176, 207, 0.1)"
                    }
                },
                axisLabel: {
                    formatter: '{value}'
                },
            }
        ],
        series: [
            {
                name: "Bookings",
                type: "bar",
                data: data.map(({ TotalBooking }) => TotalBooking),
            },
            // {
            //   name: "Precipitation",
            //   type: "bar",
            //   data: [2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2],
            // },
            // {
            //   name: "Average Temperature",
            //   type: "line",
            //   yAxisIndex: 1,
            //   data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4],
            // },
        ],
        textStyle: {
            color: ["#74788d"],
        },
    }


    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    <h3 className="card-title mb-4">Bookings</h3>
                    <Row></Row>
                    <Row style={{ display: "flex", justifyContent: "end" }}>
                        <Col md={3}>
                            <div style={{ marginTop: "4px" }}>
                                <div className=" d-flex gap-2">
                                    <FormGroup>
                                        <Input
                                            type="radio"
                                            value="MONTH"
                                            id="Month"
                                            // name="gender"
                                            className="form-check-input"
                                            checked={filterType == "MONTH"}
                                            onClick={() => { setFilterType("MONTH") }}
                                        />
                                    </FormGroup>
                                    <Label className="form-check-label font-size-13 me-2" htmlFor="Month">
                                        Month
                                    </Label>
                                    <FormGroup>
                                        <Input
                                            type="radio"
                                            value="YEAR"
                                            id="Year"
                                            // name="gender"
                                            className="form-check-input"
                                            checked={filterType == "YEAR"}
                                            onClick={() => { setFilterType('YEAR') }}
                                        />
                                    </FormGroup>
                                    <Label className="form-check-label font-size-13 me-2" htmlFor="Year">
                                        Year
                                    </Label>
                                    <FormGroup>
                                        <Input
                                            type="radio"
                                            value='ALL'
                                            id="All"
                                            // name="gender"
                                            className="form-check-input"
                                            checked={filterType == "ALL"}
                                            onClick={() => { setFilterType('ALL') }}
                                        />
                                    </FormGroup>
                                    <Label className="form-check-label font-size-13" htmlFor="All">
                                        All
                                    </Label>
                                </div>
                            </div>
                        </Col>
                        <Col md="3" className="table-header" >
                            <div style={{ display: "flex", justifyContent: "end", gap: "12px" }}>
                                <div className="input-group input-group-sm">
                                    <select
                                        className="form-select form-select-sm"
                                        value={selectedYear}
                                        onChange={(e) => setSelectedYear(e.target.value)}
                                        disabled={filterType === "ALL"}
                                    >
                                        {years.map((item, index) => (
                                            <option value={item.value} key={index}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </select>
                                    <label className="input-group-text">Year</label>
                                </div>
                                <div className="input-group input-group-sm">
                                    <select
                                        className="form-select form-select-sm"
                                        value={seletedMonth}
                                        onChange={e => setSeletedMonth(e.target.value)}
                                        disabled={filterType == "YEAR" || filterType == "ALL"}
                                    >
                                        {/* {dates.map(({ month }, index) => (
                                            <option value={index} key={index}>
                                                {month}
                                            </option>
                                        ))} */}
                                        {months.map((item, index) => (
                                            <option value={item.value} key={index}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </select>
                                    <label className="input-group-text">Month</label>
                                </div>
                            </div>
                        </Col>

                    </Row>
                    <ReactEcharts style={{ height: "320px" }} option={options} />
                </CardBody>
            </Card>
        </React.Fragment >
    );
};

export default LineBar;
